// @ts-expect-error file not converted to TS yet
import Cookie from 'js-cookie';
import { LOGIN_METADATA_COOKIE_NAME } from '../constants/cookies';
const getParsedLoginMetadataCookie = () => {
  const loginMetadataCookie = Cookie.get(LOGIN_METADATA_COOKIE_NAME);
  return JSON.parse(loginMetadataCookie.replace(/\\"/g, '"'));
};
export const getIsUngatedForLoginV4 = () => {
  try {
    const loginMetadata = getParsedLoginMetadataCookie();
    return loginMetadata.ungatedForLoginV4;
  } catch (_unused) {
    return false;
  }
};
export const getShowABTestVariant = () => {
  try {
    const loginMetadata = getParsedLoginMetadataCookie();
    return loginMetadata.showABTestVariant;
  } catch (_unused2) {
    return null;
  }
};